import React, { useState } from "react";
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from "react-router-dom";
import "./ProtectedRoute.css";
import { IoWarningOutline } from "react-icons/io5";
import { FaExclamationCircle } from "react-icons/fa";

const SessionExpiredPopup = ({ onConfirm }) => (
	<div className="session-overlay">
		<div className="session-popup">
			<h2 className="session-title">
				<IoWarningOutline className="session-icon"/> Session Expired
			</h2>
			<p className="session-message">
				Your session has expired. Please log in again to continue.
			</p>
			<div className="session-actions">
				<button className="session-confirm-btn" onClick={onConfirm}>
					Go to Home
				</button>
			</div>
		</div>
	</div>
);

const RestrictedAccessPopup = ({onConfirm}) => {
	return (
		<div className="restricted-overlay">
			<div className="restricted-popup">
				<FaExclamationCircle className="restricted-icon" />
				<h2 className="restricted-title">Access Restricted</h2>
				<p className="restricted-message">Only admin can access this page.</p>
				<button className="restricted-close-btn" onClick={onConfirm}>
					Close
				</button>
			</div>
		</div>
	);
};

const isAuthenticated = (setSessionExpired) => {
	const token = localStorage.getItem("adminToken");
	if (!token) return false;

	try {
		const decoded = jwtDecode(token);
		if (decoded.exp * 1000 < Date.now()) {
			localStorage.clear();
			setSessionExpired(true);
			return false;
		}
		return true;
	} catch (error) {
		localStorage.clear();
		setSessionExpired(true);
		return false;
	}
};

const ProtectedRoute = ({ element }) => {
	const navigate = useNavigate();
	const [sessionExpired, setSessionExpired] = useState(false);

	if (sessionExpired) {
		return (
			<SessionExpiredPopup
				onConfirm={() => {
					navigate("/");
				}}
			/>
		);
	}

	return isAuthenticated(setSessionExpired) ? element : <RestrictedAccessPopup onConfirm={() => {
		navigate("/");
	}}/>;
};

export default ProtectedRoute;
